"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Home = _interopRequireDefault(require("./components/pages/Home"));

require("../css/App.css");

var _utils = _interopRequireDefault(require("./config/utils"));

var _store = _interopRequireDefault(require("./redux/store")); // Redux


function App(_ref) {
  var onLastSave = _ref.onLastSave,
      appHeight = _ref.appHeight;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactRedux.Provider, {
      store: _store["default"]
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "app"
    },
    /*#__PURE__*/
    _react["default"].createElement(_Home["default"], {
      onLastSave: onLastSave,
      appHeight: appHeight
    })))
  );
} // expose store when run in Cypress


if (window.Cypress) {
  window.store = _store["default"];
}

var _default = exports["default"] = App;

if (!window.pdfFormConfigObject) {
  (0, _utils["default"])();
}

App.defaultProps = {
  appHeight: window.innerHeight
};
App.propTypes = process.env.NODE_ENV !== "production" ? {
  onLastSave: _propTypes["default"].func.isRequired,
  appHeight: _propTypes["default"].number
} : {};